import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import { reducers } from './reucers';

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers
});

export const { SET_DEVICE } = appSlice.actions;
export default appSlice.reducer;